<template>
  <div class="container-fluid p-0" v-if="user">
    
    <!-- Cards de Métricas (Apenas Admin) -->
    <div class="row mb-5 mt-4" v-if="user.role === 'ADMIN' && metrics">
      <div class="col-xl-3 col-lg-6 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <i class="material-icons opacity-10">campaign</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Cadastradas</p>
              <h4 class="mb-0">{{ metrics.total_campaigns }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-6 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div class="icon icon-lg icon-shape bg-gradient-warning shadow-warning text-center border-radius-xl mt-n4 position-absolute">
              <i class="material-icons opacity-10">pending_actions</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Aguardando Pagamento</p>
              <h4 class="mb-0">{{ metrics.waiting_campaigns }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-6 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div class="icon icon-lg icon-shape bg-gradient-success shadow-success text-center border-radius-xl mt-n4 position-absolute">
              <i class="material-icons opacity-10">account_balance_wallet</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Carteira do Sistema</p>
              <h4 class="mb-0">{{ metrics.system_wallet_campaigns }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-6 col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-header p-3 pt-2">
            <div class="icon icon-lg icon-shape bg-gradient-info shadow-info text-center border-radius-xl mt-n4 position-absolute">
              <i class="material-icons opacity-10">payments</i>
            </div>
            <div class="text-end pt-1">
              <p class="text-sm mb-0 text-capitalize">Pagaram Taxa</p>
              <h4 class="mb-0">{{ metrics.paid_fee_campaigns }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista de Campanhas -->
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg p-3 p-sm-4 d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <h6 class="text-white text-capitalize m-0 font-weight-bolder">Campanhas</h6>

              <button
                class="btn btn-icon btn-3 campaign-btn m-0"
                type="button"
                @click="newRaffle"
                v-if="user.role == 'USER'"
              >
                <span class="btn-inner--icon"
                  ><i class="material-icons btn-icon"
                    >add_circle_outline</i
                  ></span
                >
                <span class="btn-inner--text btn-text">NOVA CAMPANHA</span>
              </button>
            </div>
          </div>

          <div class="card-body px-1 pb-2">
            <div v-if="user.role === 'ADMIN'" class="px-3">
              <div>
                <label class="input-label w-100">
                  <span
                    class="text-xs text-uppercase text-body font-weight-bolder"
                  >
                    Selecione um usuário
                  </span>
                  <div class="d-flex align-items-center position-relative">
                    <AutoComplete
                      v-model="userSelected"
                      dropdown
                      optionLabel="full_name"
                      @complete="searchCountry"
                      @option-select="handleUser"
                      @clear="handleClear"
                      :suggestions="filteredUsers"
                      placeholder="Selecione..."
                      class="bordered-autocomplete"
                      emptySearchMessage="Nenhum usuário encontrado"
                    />
                  </div>
                </label>
              </div>
            </div>

            <!-- Filtros: Campo de pesquisa e Carteira do Sistema -->
            <div class="row px-3 mb-3 align-items-end">
              <div :class="user.role === 'ADMIN' ? 'col-md-8' : 'col-12'">
                <label class="input-label w-100 mb-0">
                  <span
                    class="text-xs text-uppercase text-body font-weight-bolder"
                  >
                    Pesquisar por nome da campanha
                  </span>
                  <div class="d-flex align-items-center position-relative">
                    <input
                      v-model="searchTerm"
                      @input="debounceSearch"
                      @keyup.enter="performSearch"
                      type="text"
                      class="form-control"
                      placeholder="Digite o nome da campanha..."
                    />
                    <i
                      class="material-icons position-absolute end-0 me-3"
                      style="color: #adb5bd"
                      >search</i
                    >
                  </div>
                </label>
              </div>
              
              <div class="col-md-4 mt-3 mt-md-0 d-flex align-items-center justify-content-md-end" v-if="user.role === 'ADMIN'">
                <div class="form-check form-switch mb-0 pb-1">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="systemWalletFilter" 
                    v-model="filterSystemWallet" 
                    @change="performSearch"
                  >
                  <label 
                    class="form-check-label mb-0 text-xs text-uppercase text-body font-weight-bolder" 
                    for="systemWalletFilter" 
                    style="cursor: pointer;"
                  >
                    Carteira do Sistema
                  </label>
                </div>
              </div>
            </div>
            <!-- Dica visual animada exclusiva para Mobile -->
            <div class="d-md-none mx-2 mb-3 p-2 px-3 border-radius-lg mobile-swipe-hint d-flex align-items-center justify-content-between" v-if="raffles.length > 0">
              <div class="d-flex align-items-center">
                <span class="swipe-pulse-badge me-2">
                  <i class="material-icons text-sm">swipe</i>
                </span>
                <span class="text-xxs font-weight-bolder text-dark text-uppercase">
                  Deslize para o lado para ver <strong>Link</strong> e <strong>Ações</strong>
                </span>
              </div>
              <div class="swipe-arrows d-flex align-items-center">
                <i class="material-icons text-xs text-primary arrow-anim">chevron_right</i>
                <i class="material-icons text-xs text-primary arrow-anim delay-1">chevron_right</i>
              </div>
            </div>

            <div class="table-responsive p-0" v-if="raffles.length > 0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Campanha
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Status
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7"
                    >
                      Cotas Vendidas
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7"
                    >
                      Arrecadação
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7"
                    >
                      Taxa de Publicação
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7"
                    >
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(r, index) in raffles" :key="r.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <img
                            v-if="r.images[0]"
                            :src="r.images[0]"
                            class="avatar avatar-sm me-3 border-radius-lg campaign-image"
                            alt="user1"
                          />
                          <img
                            v-else
                            src="@/assets/img/NoImgAdded.png"
                            class="avatar avatar-sm me-3 border-radius-lg"
                            alt="user1"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ r.name }}</h6>
                          <span class="text-xs text-secondary mb-0">
                            Criado em
                            <span class="countdown-text"
                              >{{ new Date(r.created_at).toLocaleDateString() }}
                              às
                              {{
                                new Date(r.created_at).toLocaleTimeString()
                              }}</span
                            >
                            <template v-if="user.role === 'ADMIN'">
                              por
                              <button
                                class="creator-link"
                                @click="navigateToOrders(r.user.id, r.id)"
                              >
                                {{ r.user.full_name }}
                              </button>
                            </template>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <div
                        v-if="r.status == 'WAITING'"
                        class="d-flex flex-column align-items-center"
                      >
                        <span class="countdown-box">
                          {{ getCountdown(r.due_date) }}
                        </span>
                      </div>

                      <span
                        class="badge badge-sm bg-gradient-success"
                        v-if="r.status == 'ACTIVE'"
                        >ATIVA</span
                      >
                      <span
                        class="badge badge-sm bg-gradient-secondary"
                        v-if="r.status == 'FINISHED'"
                        >FINALIZADA</span
                      >
                    </td>

                    <td class="align-middle text-center">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        <span class="text-xs font-weight-bold"
                          >{{
                            (
                              ((r.qnt_quotas - r.remaining_quotas) * 100) /
                              r.qnt_quotas
                            ).toFixed(2)
                          }}%</span
                        >
                        <div>
                          <div class="progress mx-2">
                            <div
                              class="progress-bar bg-gradient-success"
                              role="progressbar"
                              :aria-valuenow="
                                ((r.qnt_quotas - r.remaining_quotas) * 100) /
                                r.qnt_quotas
                              "
                              aria-valuemin="0"
                              :aria-valuemax="100"
                              :style="`width: ${
                                ((r.qnt_quotas - r.remaining_quotas) * 100) /
                                r.qnt_quotas
                              }%`"
                            ></div>
                          </div>
                        </div>
                        <span class="text-xs font-weight-bold"
                          >{{
                            (r.qnt_quotas - r.remaining_quotas).toLocaleString()
                          }}
                          / {{ r.qnt_quotas.toLocaleString() }}</span
                        >
                      </div>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bold">
                        {{ turnIntoMoney(r.total_collected) }}
                      </span>
                    </td>

                    <td class="align-middle text-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="text-xs font-weight-bold">
                          {{ turnIntoMoney(r.publication_fee) }}
                        </span>
                        <i
                          v-if="r.system_wallet && user.role === 'ADMIN'"
                          class="material-icons text-success ms-2"
                          style="font-size: 18px;"
                          title="Campanha com carteira do sistema"
                        >account_balance_wallet</i>
                      </div>
                    </td>

                    <td class="align-middle">
                      <div class="d-flex align-items-center justify-content-center gap-2">
                        <!-- Ação Rápida 1: Copiar Link Direto (Ativa) -->
                        <button
                          v-if="r.status === 'ACTIVE'"
                          type="button"
                          class="btn-action-pill btn-action-copy"
                          title="Copiar Link Oficial da Rifa"
                          @click="copyLink(r.slug)"
                        >
                          <i class="material-icons">link</i>
                          <span>Copiar Link</span>
                        </button>

                        <!-- Ação Rápida 2: Gerar QR Code para Banners/Panfletos (Ativa) -->
                        <button
                          v-if="r.status === 'ACTIVE'"
                          type="button"
                          class="btn-action-icon-circle btn-action-qr"
                          title="Gerar QR Code para Banner ou Stories"
                          @click="openQrCodeModal(r)"
                        >
                          <i class="material-icons">qr_code_2</i>
                        </button>

                        <!-- Ação Rápida: Pagar (Pendente) -->
                        <button
                          v-if="r.status === 'WAITING' && user.role === 'USER'"
                          type="button"
                          class="btn-action-pill btn-action-pay"
                          title="Pagar Taxa de Publicação"
                          @click="$router.push(`/raffles/pay/${r.slug}`)"
                        >
                          <i class="material-icons">pix</i>
                          <span>Pagar</span>
                        </button>

                        <!-- Menu de Mais Opções (Modernizado) -->
                        <button
                          type="button"
                          class="btn-action-more"
                          title="Mais opções de gerenciamento"
                          @click="toggle(index, $event)"
                        >
                          <i class="material-icons">more_horiz</i>
                        </button>

                        <PrimeMenu
                          :ref="(el) => setMenuRef(el, index)"
                          :id="`overlay_menu_${index}`"
                          :model="getMenuItems(r)"
                          :popup="true"
                        >
                          <template #item="{ item, props }">
                            <a v-bind="props.action" class="d-flex align-items-center w-100">
                                <span :class="[item.icon, 'p-menuitem-icon']" />
                                <span class="p-menuitem-text">{{ item.label }}</span>
                                <span v-if="item.badge" class="badge badge-sm bg-gradient-warning ms-2" style="font-size: 0.55rem; padding: 2px 4px;">{{ item.badge }}</span>
                            </a>
                          </template>
                        </PrimeMenu>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <Paginator
                v-if="pages > 1"
                v-model:first="currentPage"
                :rows="1"
                :totalRecords="pages"
                @page="onPageChange"
              />
            </div>

            <div class="no-campaign" v-else>
              <i class="material-icons">summarize</i>
              <span v-if="searchTerm.trim() && raffles.length === 0">
                Nenhuma campanha encontrada com o termo "{{ searchTerm }}".
              </span>
              <span v-else-if="user.role === 'USER'">
                Você ainda não criou nenhuma campanha.
              </span>
              <span v-else> Nenhuma campanha encontrada. </span>
              <span v-if="!searchTerm.trim() && user.role === 'USER'">
                Para criar, basta clicar em <strong>criar campanha</strong> e
                preencher os dados solicitados.
              </span>
              <span v-if="searchTerm.trim() && raffles.length === 0">
                Tente usar outros termos de pesquisa.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="loading" />

    <SetWinnersDialog
      :isOpen="winnersDialog"
      :isLoading="isLoadingPrizes"
      :prizes="prizes"
      :campaignId="raffleId"
      :qntQuotas="winnersQntQuotas"
      :isDetails="isDetails"
      @close="closeWinnersDialog"
      @endCampaign="getRaffles"
    />


    <AffiliateConfigModal v-if="showAffiliateConfig" :campaign-prop="selectedAffiliateCampaign" @close="handleCloseAffiliateConfig" />
    <AffiliationAnnouncementModal v-if="showAffiliationAnnouncement" @close="handleCloseAffiliationAnnouncement" />
    <PaymentMethodRequiredModal v-if="showPaymentMethodRequired" @close="showPaymentMethodRequired = false" />
    
    <!-- Modal Oficial de Gerar QR Code para Banners/Stories -->
    <CampaignQrCodeModal
      v-if="showQrCodeModal"
      :is-open="showQrCodeModal"
      :campaign="selectedQrCampaign"
      :user="user"
      @close="closeQrCodeModal"
    />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import PrimeMenu from "primevue/menu";
import SetWinnersDialog from "./components/SetWinnersDialog.vue";
import WinnersHttp from "@/http/WinnersHttp.js";
import { AutoComplete, Paginator } from "primevue";
import { addMoneyMask } from "@/helpers/moneyMask.js";
import LoggingMixin from "@/mixins/LoggingMixin";

import RafflesHttp from "@/http/RafflesHttp.js";
import UsersHttp from "@/http/UsersHttp.js";
import PaymentHttp from "@/http/PaymentHttp.js";

import AffiliateConfigModal from "@/components/AffiliateConfigModal.vue";
import AffiliationAnnouncementModal from "@/components/AffiliationAnnouncementModal.vue";
import PaymentMethodRequiredModal from "@/components/PaymentMethodRequiredModal.vue";
import CampaignQrCodeModal from "./components/CampaignQrCodeModal.vue";
import { buildCampaignPublicUrl } from "@/store/config.js";

export default {
  name: "raffles",
  mixins: [LoggingMixin],
  components: {
    Loading,
    PrimeMenu,
    SetWinnersDialog,
    AutoComplete,
    Paginator,

    AffiliateConfigModal,
    AffiliationAnnouncementModal,
    PaymentMethodRequiredModal,
    CampaignQrCodeModal,
  },
  data() {
    return {
      user: null,

      showAffiliateConfig: false,
      selectedAffiliateCampaign: null,
      showAffiliationAnnouncement: false,
      showPaymentMethodRequired: false,
      pendingPaymentMethodRequired: false,
      showQrCodeModal: false,
      selectedQrCampaign: null,
      pages: 0,
      userSelected: null,
      raffles: [],
      loading: true,
      items: [],
      winnersDialog: false,
      isDetails: false,
      rafflePrizes: [],
      isLoadingPrizes: false,
      raffleId: null,
      winnersQntQuotas: null,
      filteredUsers: [],
      currentPage: 0,
      menuRefs: [],
      prizes: null,
      searchTerm: "",
      searchTimeout: null,
      filterSystemWallet: false,
      metrics: {
        total_campaigns: 0,
        waiting_campaigns: 0,
        system_wallet_campaigns: 0,
        paid_fee_campaigns: 0
      },
    };
  },
  async mounted() {
    this.user = this.$store.getters.user;

    // Check for Promo Modal
    if (
      this.user &&
      !localStorage.getItem("campaign_affiliation_launch_seen") &&
      this.user.role === "USER"
    ) {
      this.showAffiliationAnnouncement = true;
    }

    await this.init();

    // Check for configured payment methods (não empilha com o modal de afiliação)
    if (this.user && this.user.role === "USER") {
      if (this.user.system_wallet === true || this.user.system_wallet === "true") {
        this.showPaymentMethodRequired = false;
      } else {
        try {
          const response = await PaymentHttp.getPaymentProviders();
          const providers = Array.isArray(response.data) ? response.data : [];
          const hasConfiguredProvider = providers.some(provider => {
            if (!provider.data) return false;
            let dataStr = typeof provider.data === 'string' ? provider.data.trim() : JSON.stringify(provider.data);
            return dataStr !== '{}' && dataStr !== '';
          });

          if (!hasConfiguredProvider) {
            if (this.showAffiliationAnnouncement) {
              this.pendingPaymentMethodRequired = true;
            } else {
              this.showPaymentMethodRequired = true;
            }
          }
        } catch (err) {
          console.error("Erro ao verificar métodos de pagamento:", err);
        }
      }
    }

    setInterval(() => {
      this.$forceUpdate();
    }, 1000);
  },
  beforeUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  methods: {
    closeWinnersDialog() {
      this.winnersDialog = false;
    },
    setMenuRef(el, index) {
      if (el) {
        this.menuRefs[index] = el;
      }
    },
    getCountdown(dueDate) {
      const now = new Date();
      const due = new Date(dueDate);
      const diff = due - now;

      if (diff <= 0) return "TEMPO EXPIRADO";

      const hours = Math.floor(diff / 1000 / 60 / 60);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      return `PAGUE EM ATÉ: ${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
    async init() {
      this.loading = true;
      if (this.user.role == "USER") {
        await this.getRaffles();
      }

      if (this.user.role == "ADMIN") {
        await this.getUsers();
        await this.getMetrics();
        await this.getLastRaffles(1);
      }
      this.loading = false;
    },
    async getMetrics() {
      try {
        const response = await RafflesHttp.getAdminCampaignsMetrics();
        this.metrics = response.data;
      } catch (error) {
        console.error("Error fetching metrics:", error);
      }
    },
    async getUsers() {
      try {
        const response = await UsersHttp.getUsersMinimum();
        this.users = response.data;
        this.filteredUsers = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async handleUser(e) {
      let id_user = e.value;
      this.userSelected = id_user;
      await this.getRafflesByUserId(id_user.id, this.searchTerm.trim());
    },
    searchCountry(e) {
      this.filteredUsers = this.users.filter((country) => {
        return country.full_name
          .toLowerCase()
          .startsWith(e.query.toLowerCase());
      });
    },
    async getRafflesByUserId(id, search = "") {
      try {
        this.loading = true;

        const response = await RafflesHttp.getRafflesByUser(id, search);
        
        let filteredData = response.data;
        
        if (search) {
          filteredData = filteredData.filter(r => r.name.toLowerCase().includes(search.toLowerCase()));
        }
        
        if (this.filterSystemWallet) {
          filteredData = filteredData.filter(r => r.system_wallet === true);
        }
        
        this.raffles = filteredData;
        this.pages = 0;
        this.currentPage = 0;

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async getLastRaffles(page, search = "") {
      try {
        this.loading = true;
        const response = await RafflesHttp.getAdminCampaigns(page, search, this.filterSystemWallet);
        this.raffles = response.data.campaigns;
        this.pages = response.data.pages;
        this.currentPage = page - 1;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async onPageChange(event) {
      const page = event.page + 1;
      if (this.user.role === "USER") {
        await this.getRaffles(this.searchTerm.trim(), page);
      } else {
        await this.getLastRaffles(page, this.searchTerm.trim());
      }
    },
    async getRaffles(search = "", page = 1) {
      try {
        this.loading = true;
        const response = await RafflesHttp.getCampaigns(search, page, 10);

        const now = new Date();

        this.raffles = (response.data.campaigns || []).filter((raffle) => {
          if (raffle.status === "WAITING") {
            const dueDate = new Date(raffle.due_date);
            return dueDate > now;
          }
          return true;
        });
        this.pages = response.data.pages || 0;
        this.currentPage = page - 1;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    debounceSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.performSearch();
      }, 500);
    },
    async performSearch() {
      const search = this.searchTerm.trim();

      if (this.user.role === "USER") {
        await this.getRaffles(search, 1);
      } else if (this.user.role === "ADMIN") {
        if (this.userSelected) {
          await this.getRafflesByUserId(this.userSelected.id, search);
        } else {
          await this.getLastRaffles(1, search);
        }
      }
    },
    async markPaid(id) {
      try {
        const result = await this.$swal.fire({
          title: "Marcar campanha como ativa?",
          text: "Deseja marcar a campanha como ativa?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          confirmButtonColor: "#e41b80",
          cancelButtonColor: "#6c757d",
          allowOutsideClick: false,
        });

        if (!result.isConfirmed && !result.value) {
          return;
        }

        this.$swal.fire({
          title: "Aguarde...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        try {
          await RafflesHttp.markActive(id);

          const raffle = this.raffles.find((r) => r.id === id);
          if (raffle) {
            raffle.status = "ACTIVE";
          }

          if (this.userSelected?.id) {
            await this.getRafflesByUserId(
              this.userSelected.id,
              this.searchTerm.trim()
            );
          } else {
            await this.getLastRaffles(this.currentPage + 1 || 1, this.searchTerm.trim());
          }

          if (this.user.role === "ADMIN") {
            await this.getMetrics();
          }

          const campName = raffle?.name || `ID ${id}`;
          this.$log.log(
            "CAMPANHAS",
            "AÇÃO",
            `Administrador marcou a campanha "${campName}"${
              this.userSelected?.full_name
                ? ` do usuário "${this.userSelected.full_name}"`
                : ""
            } como ATIVA`
          );

          this.$toast.add({
            severity: "success",
            summary: "Sucesso!",
            detail: "Campanha marcada como ativa.",
            life: 3000,
          });
        } catch (error) {
          console.error(error);
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail:
              error?.error ||
              error?.message ||
              "Não foi possível marcar a campanha como ativa.",
            life: 4000,
          });
        } finally {
          this.$swal.close();
        }
      } catch (error) {
        console.error(error);
        if (this.$swal?.isVisible?.()) {
          this.$swal.close();
        }
      }
    },
    newRaffle() {
      this.$router.push({ name: "Nova campanha" });
    },
    toggle(index, event) {
      const menu = this.menuRefs[index];
      if (menu) menu.toggle(event);
    },
    copyLink(slug) {
      const link = buildCampaignPublicUrl(slug, this.user);
      navigator.clipboard
        .writeText(link)
        .then(() => {
          const raffle = this.raffles.find((r) => r.slug === slug);
          const campName = raffle?.name || slug;
          this.$log.log("CAMPANHAS", "AÇÃO", `Usuário copiou o link da campanha "${campName}"`);
          this.$toast.add({
            severity: "success",
            summary: "Link copiado!",
            detail: "O link foi copiado para a área de transferência.",
            life: 3000,
          });
        })
        .catch((err) => {
          console.error("Erro ao copiar link:", err);
          this.$toast.add({
            severity: "error",
            summary: "Erro!",
            detail: "Não foi possível copiar o link.",
            life: 3000,
          });
        });
    },
    winnersPublicUrl(slug) {
      return `${buildCampaignPublicUrl(slug, this.user)}/ganhadores`;
    },
    openWinnersPublicPage(slug) {
      window.open(this.winnersPublicUrl(slug), "_blank");
    },
    copyWinnersLink(slug) {
      const link = this.winnersPublicUrl(slug);
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Link copiado!",
            detail: "Link da página de ganhadores copiado.",
            life: 3000,
          });
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            summary: "Erro!",
            detail: "Não foi possível copiar o link.",
            life: 3000,
          });
        });
    },
    async toggleWinnersPage(raffle, enabled) {
      try {
        await RafflesHttp.updateShowWinnersPage(raffle.id, enabled);
        raffle.show_winners_page = enabled;
        this.$toast.add({
          severity: "success",
          summary: enabled ? "Página ativada" : "Página desativada",
          detail: enabled
            ? "A página pública de ganhadores está no ar."
            : "A página pública de ganhadores foi desativada.",
          life: 3500,
        });
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail:
            error?.error ||
            error?.message ||
            "Não foi possível atualizar a página de ganhadores.",
          life: 4000,
        });
      }
    },
    async openWinnersDialog(id) {
      this.isLoadingPrizes = true;
      this.isDetails = false;

      try {
        this.winnersDialog = true;
        const response = await WinnersHttp.getAwards(id);
        this.raffleId = id;
        const raffle = this.raffles.find((r) => r.id === id);
        this.winnersQntQuotas = raffle?.qnt_quotas ?? null;
        this.prizes = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoadingPrizes = false;
      }
    },
    async openWinnersDetailsDialog(id) {
      this.isLoadingPrizes = true;
      this.isDetails = true;

      try {
        this.winnersDialog = true;
        const response = await WinnersHttp.getAwards(id);
        this.raffleId = id;
        const raffle = this.raffles.find((r) => r.id === id);
        this.winnersQntQuotas = raffle?.qnt_quotas ?? null;
        this.prizes = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoadingPrizes = false;
      }
    },
    openUrl(name) {
      const raffle = this.raffles.find((r) => r.slug === name);
      const campName = raffle?.name || name;
      this.$log.log("CAMPANHAS", "AÇÃO", `Usuário abriu a página pública da campanha "${campName}" em nova aba`);
      window.open(buildCampaignPublicUrl(name, this.user), "_blank");
    },
    async handleClear() {
      await this.init();
    },
    turnIntoMoney(value) {
      return addMoneyMask(value);
    },
    navigateToOrders(userId, campaignId) {
      const query = { campaign: campaignId };

      if (userId !== 0) {
        query.user = userId;
      }

      this.$router.push({
        path: "/orders",
        query: query,
      });
    },
    getMenuItems(r) {
      const items = [...this.items];

      if (r.qnt_quotas - r.remaining_quotas > 0 && this.user.role === "USER") {
        items.push({
          label: "Ver histórico de vendas",
          command: () => {
            this.$log.log("PEDIDOS", "ACESSO", `Usuário clicou em "Ver histórico de vendas" da campanha "${r.name}"`);
            this.navigateToOrders(0, r.id);
          },
        });
      }

      if (r.status !== "ACTIVE" && this.user.role === "ADMIN") {
        items.push({
          label: "Marcar como ativa",
          command: () => this.markPaid(r.id),
        });
      }

      if (r.status === "WAITING" && this.user.role === "USER") {
        items.push({
          label: "Pagar",
          command: () => {
            this.$log.log("CAMPANHAS", "AÇÃO", `Usuário clicou em "Pagar" para a campanha "${r.name}" (aguardando pagamento)`);
            this.$router.push(`/raffles/pay/${r.slug}`);
          },
        });
      }

      if (r.status !== "FINISHED") {
        items.push({
          label: "Editar campanha",
          command: () => {
            this.$log.log("CAMPANHAS", "AÇÃO", `Usuário clicou em "Editar campanha" para a campanha "${r.name}"`);
            this.$router.push(`/raffles/${r.slug}/edit`);
          },
        });
      }

      if (r.status === "ACTIVE" && this.user.role === "USER") {
        items.push({
          label: "Informar ganhador(es)",
          command: () => {
            this.$log.log("CAMPANHAS", "AÇÃO", `Usuário clicou em "Informar ganhador(es)" da campanha "${r.name}"`);
            this.openWinnersDialog(r.id);
          },
        });
      }

      if (r.status === "FINISHED") {
        items.push({
          label: "Ver ganhador(es)",
          command: () => {
            this.$log.log("CAMPANHAS", "ACESSO", `Usuário visualizou os ganhadores da campanha "${r.name}"`);
            this.openWinnersDetailsDialog(r.id);
          },
        });

        if (r.show_winners_page) {
          items.push({
            label: "Abrir página pública",
            command: () => this.openWinnersPublicPage(r.slug),
          });
          items.push({
            label: "Copiar link dos ganhadores",
            command: () => this.copyWinnersLink(r.slug),
          });
          items.push({
            label: "Desativar página pública",
            command: () => this.toggleWinnersPage(r, false),
          });
        } else {
          items.push({
            label: "Ativar página pública",
            command: () => this.toggleWinnersPage(r, true),
          });
        }
      }

      if (r.status === "ACTIVE") {
        items.push({
          label: "Gerar QR Code (Banner/Arte)",
          icon: "material-icons text-info",
          command: () => this.openQrCodeModal(r),
        });
        items.push({
          label: "Copiar link",
          command: () => this.copyLink(r.slug),
        });
        items.push({
          label: "Abrir em nova guia",
          command: () => this.openUrl(r.slug),
        });
      } else {
        items.push({
          label: "Copiar link",
          command: () => this.copyLink(r.slug),
        });
      }

      if (this.user.role === "USER") {
        items.push({
          label: "Configurar afiliados",
          badge: "Novo",
          command: () => {
            this.$log.log("CAMPANHAS", "AÇÃO", `Usuário abriu o modal de configuração de afiliados para a campanha "${r.name}"`);
            this.handleOpenAffiliateConfig(r);
          },
        });
      }

      return items;
    },
    handleOpenAffiliateConfig(campaign) {
      this.selectedAffiliateCampaign = campaign;
      this.showAffiliateConfig = true;
    },
    handleCloseAffiliateConfig() {
      this.showAffiliateConfig = false;
    },
    openQrCodeModal(campaign) {
      this.selectedQrCampaign = campaign;
      this.showQrCodeModal = true;
      this.$log.log("CAMPANHAS", "AÇÃO", `Usuário abriu o gerador de QR Code da campanha "${campaign.name}"`);
    },
    closeQrCodeModal() {
      this.showQrCodeModal = false;
      this.selectedQrCampaign = null;
    },
    async handleCloseAffiliationAnnouncement() {
      this.showAffiliationAnnouncement = false;
      try {
        await UsersHttp.markAffiliationModalSeen();
        this.user.seen_affiliation_modal = true;
        this.$store.commit('setUser', this.user)
      } catch (error) {
        console.error("Failed to mark affiliation modal seen", error);
      }

      if (this.pendingPaymentMethodRequired) {
        this.pendingPaymentMethodRequired = false;
        this.showPaymentMethodRequired = true;
      }
    },

  },
};
</script>

<style scoped lang="scss">
.campaign-btn {
  background-color: #ffffff !important;
  color: #1e1b4b !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px !important;
  border-radius: 10px !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12) !important;
  white-space: nowrap;

  .btn-icon {
    font-size: 1.2rem;
    color: #e41b80;
  }

  .btn-text {
    color: #1e1b4b;
    letter-spacing: 0.02em;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.18) !important;
  }
}

.more-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===== Botões de Ação Modernizados ===== */
.btn-action-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: none;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 0.72rem;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  i {
    font-size: 15px;
  }
}

.btn-action-copy {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #ffffff;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
  }

  &:active {
    transform: translateY(0);
  }
}

.btn-action-pay {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #ffffff;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.35);
  }
}

.btn-action-icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.btn-action-qr {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: #ffffff;

  i {
    font-size: 17px;
  }

  &:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
  }
}

.btn-action-more {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.04);

  i {
    font-size: 20px;
  }

  &:hover {
    background: #f8fafc;
    color: #1e1b4b;
    border-color: #cbd5e1;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  }
}

.no-campaign {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
  padding: 50px 0;
  text-align: center;
}

.filters {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}

.campaign-image {
  object-fit: cover;
}

.countdown-box {
  font-size: 0.75rem;
  color: #fea11d;
  background: #fff5e6;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid #fea11d;
  font-weight: 600;
  display: inline-block;
}

.creator-link {
  background: none;
  border: none;
  padding: 0;
  color: #e41b80;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    color: #c21668;
    text-decoration: underline;
  }

  &:focus {
    outline: none;
  }
}

/* ===== Dica Visual no Mobile (Swipe Hint) ===== */
.mobile-swipe-hint {
  background: linear-gradient(135deg, #eef2ff 0%, #fdf2f8 100%);
  border: 1px dashed #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
}

.swipe-pulse-badge {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #6366f1;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.5);
  animation: pulseSwipe 1.8s infinite;

  i {
    font-size: 15px;
  }
}

@keyframes pulseSwipe {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.6);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(99, 102, 241, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(99, 102, 241, 0);
  }
}

.arrow-anim {
  animation: slideArrow 1.2s infinite ease-in-out;

  &.delay-1 {
    animation-delay: 0.25s;
    margin-left: -6px;
  }
}

@keyframes slideArrow {
  0%, 100% {
    transform: translateX(0);
    opacity: 0.4;
  }
  50% {
    transform: translateX(4px);
    opacity: 1;
  }
}

.input-label {
  .form-control {
    border: 1px solid #d2d6da;
    border-radius: 0.375rem;
    padding: 0.5rem 2.5rem 0.5rem 0.75rem;
    font-size: 0.875rem;
    transition: all 0.15s ease-in-out;

    &:focus {
      border-color: #e41b80;
      box-shadow: 0 0 0 0.2rem rgba(228, 27, 128, 0.25);
      outline: 0;
    }

    &::placeholder {
      color: #adb5bd;
    }
  }
}
</style>
